import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';

import { useBoolean } from '@dreryk/react-common';
import { ModalConfirmButton, usePushBack } from '@dreryk/react-components';

import { visitPaths } from '~libs.desktop.shared.paths';

import { appointmentsTranslationKeys } from '../../../translations';

import { AppointmentUpdateActionEventInterceptor } from './interceptors/AppointmentUpdateActionEventInterceptor';
import { AppointmentUpdateModal } from './shared/AppointmentUpdateModal';

type AppointmentTermUpdateModalProps = {
   readonly appointmentId: number;
};

export const AppointmentTermUpdateModal = (props: AppointmentTermUpdateModalProps): JSX.Element | null => {
   const [{ setFalse: closeModal }, modalOpened] = useBoolean(true);
   const pushBack = usePushBack();
   const location = useLocation();
   const history = useHistory();

   const handleCloseModal = useCallback((): void => {
      const searchParams = new URLSearchParams(location.search);
      searchParams.delete(visitPaths.APPOINTMENT_TERM_UPDATE_SEARCH_PARAM);

      history.replace({
         search: searchParams.toString(),
         state: location.state,
      });

      closeModal();
   }, [closeModal, history, location.search, location.state]);

   const handleSuccess = useCallback((): void => {
      pushBack(visitPaths.getAppointmentsListPath());
   }, [pushBack]);

   if (!modalOpened) {
      return null;
   }

   return (
      <AppointmentUpdateModal
         title={appointmentsTranslationKeys.update.modal.title.update}
         appointmentId={props.appointmentId}
         onClose={handleCloseModal}
         confirmButton={({ handleSubmit }) => (
            <AppointmentUpdateActionEventInterceptor appointmentId={props.appointmentId} handleSubmit={handleSubmit}>
               <ModalConfirmButton
                  label={appointmentsTranslationKeys.update.modal.confirm.update}
                  onClick={handleSuccess}
               />
            </AppointmentUpdateActionEventInterceptor>
         )}
      />
   );
};
